"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _store = require("@/api/store");

var _validate = require("@/utils/validate");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var defaultObj = {
  avatar: '',
  comment: '',
  nickname: '',
  pics: '',
  productId: '',
  productScore: null,
  serviceScore: null,
  sku: ''
};
var _default = {
  name: "creatComment",
  props: {
    num: {
      type: Number,
      required: 0
    }
  },
  data: function data() {
    var checkProductScore = function checkProductScore(rule, value, callback) {
      if (!value) {
        return callback(new Error('商品分数不能为空'));
      } else {
        callback();
      }
    };

    var checkServiceScore = function checkServiceScore(rule, value, callback) {
      if (!value) {
        return callback(new Error('服务分数不能为空'));
      } else {
        callback();
      }
    };

    return {
      loadingbtn: false,
      loading: false,
      pics: [],
      image: '',
      formValidate: Object.assign({}, defaultObj),
      rules: {
        avatar: [{
          required: true,
          message: '请选择用户头像',
          trigger: 'change'
        }],
        productId: [{
          required: true,
          message: '请选择商品',
          trigger: 'change'
        }],
        comment: [{
          required: true,
          message: '请填写评价内容',
          trigger: 'blur'
        }],
        nickname: [{
          required: true,
          message: '请填写用户名称',
          trigger: 'blur'
        }],
        pics: [{
          required: true,
          message: '请选择评价图片',
          trigger: 'change'
        }],
        productScore: [{
          required: true,
          validator: checkProductScore,
          trigger: 'blur'
        }],
        serviceScore: [{
          required: true,
          validator: checkServiceScore,
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    num: {
      handler: function handler(val) {
        this.resetForm('formValidate');
      },
      deep: true
    }
  },
  methods: {
    changeGood: function changeGood() {
      var _this = this;

      this.$modalGoodList(function (row) {
        _this.image = row.image;
        _this.formValidate.productId = row.id;
        _this.formValidate.sku = row.attrValue[0].suk;
      });
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit) {
      var _this = this;

      _this.$modalUpload(function (img) {
        tit === '1' ? _this.formValidate.avatar = img[0].sattDir : img.map(function (item) {
          _this.pics.push(item.sattDir);
        });
      }, tit, 'store');
    },
    handleRemove: function handleRemove(i) {
      this.pics.splice(i, 1);
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this2 = this;

      this.formValidate.pics = this.pics.length > 0 ? JSON.stringify(this.pics) : '';
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.loadingbtn = true;
          (0, _store.replyCreatApi)(_this2.formValidate).then(function () {
            _this2.$message.success("新增成功");

            setTimeout(function () {
              // this.clear();
              _this2.$emit('getList');
            }, 600);
            _this2.loadingbtn = false;
          }).catch(function () {
            _this2.loadingbtn = false;
          });
        } else {
          return false;
        }
      });
    }),
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.pics = [];
      this.formValidate.pics = '';
    },
    info: function info() {
      var _this3 = this;

      this.loading = true;
      (0, _store.replyInfoApi)(this.formValidate).then(function () {
        _this3.formValidate = res;
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = 'move';

      if (item === this.dragging) {
        return;
      }

      var newItems = _toConsumableArray(this.pics);

      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
      this.pics = newItems;
    }
  }
};
exports.default = _default;